module.exports = __webpack_public_path__ + "static/media/arrow-up.6638c993.svg";